import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

const NewFAQSection = () => {
  const { language } = useLanguage();
  const sl = language === 'sl';

  const faqs = sl ? [
    { q: 'Koliko stane računovodstvo?', a: 'Odvisno od prometa in števila dokumentov. Po brezplačnem posvetu prejmete fiksno pisno ponudbo v 48 urah.' },
    { q: 'Lahko računovodjo zamenjam med letom?', a: 'Da. Vodimo celoten prehod, vključno s predajo od prejšnjega računovodje.' },
    { q: 'Ali moram za ustanovitev podjetja priti osebno?', a: 'Le enkrat. Vse ostalo uredimo na daljavo s pooblastilom, običajno v 7–14 dneh.' },
    { q: 'Ali delate tudi s samostojnimi podjetniki?', a: 'Da — tudi s samostojnimi svetovalci.' },
    { q: 'Nam lahko pomagate zaposliti delavce iz držav izven EU?', a: 'Da. Uredimo dovoljenja, podaljšanja, skladnost delodajalca in obračun plač od začetka do konca.' },
    { q: 'S kom bom sodeloval?', a: 'Z osebnim skrbnikom, ki z vami komunicira v slovenščini, angleščini, srbohrvaščini ali španščini — prilagodimo se vašim potrebam.' },
  ] : [
    { q: 'How much does accounting cost?', a: 'It depends on your turnover and number of documents. After a free consultation, you receive a fixed written quote within 48 hours.' },
    { q: 'Can I switch accountants mid-year?', a: 'Yes. We handle the entire transition, including the handover from your previous accountant.' },
    { q: 'Do I need to come in person to set up a company?', a: 'Only once. Everything else is done remotely with a power of attorney, usually in 7–14 days.' },
    { q: 'Do you also work with sole proprietors?', a: 'Yes — including self-employed consultants.' },
    { q: 'Can you help us hire workers from outside the EU?', a: 'Yes. We handle permits, renewals, employer compliance and payroll from start to finish.' },
    { q: 'Who will I be working with?', a: 'A dedicated account manager who communicates with you in Slovenian, English, Serbo-Croatian or Spanish — we adapt to your needs.' },
  ];

  // FAQ Schema for SEO
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.a
      }
    }))
  };

  return (
    <section id="faq" className="bg-[#F6F2EA] py-16 lg:py-0 lg:pb-32" data-testid="faq-section">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px]">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left side */}
          <div className="lg:w-[400px] flex-shrink-0">
            <span className="text-[13px] font-bold tracking-[2.5px] text-[#7A5B28] block mb-5">
              {sl ? 'VPRAŠANJA' : 'FAQ'}
            </span>
            <h2 className="font-serif text-[48px] lg:text-[60px] leading-[1.02] tracking-[-1px] mb-4">
              {sl ? 'Jasni odgovori.' : 'Clear answers.'}
            </h2>
            <p className="text-[16px] text-[#4E5359] leading-[1.6]">
              {sl 
                ? 'Še vedno niste prepričani? Vprašajte našega asistenta v kotu — odgovori takoj, zahtevnejša vprašanja pa preda ekipi.'
                : 'Still not sure? Ask our assistant in the corner — answers instantly, and hands complex questions to the team.'}
            </p>
          </div>

          {/* Right side - FAQ list */}
          <div className="flex-1 border-t border-[#CFC7B8]">
            {faqs.map((faq) => (
              <div key={faq.q} className="py-6 border-b border-[#CFC7B8]">
                <h3 className="text-[18px] lg:text-[19px] font-bold mb-2.5">{faq.q}</h3>
                <p className="text-[16px] text-[#4E5359] leading-[1.6]">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewFAQSection;
